import React, { Fragment, useState } from "react";

import { connect } from "react-redux";
import * as actionCreator from "../../../../Store/actions/index";
import classes from "./Comments.module.css";

const Commments = (props) => {
  // console.log(props.comments, props.comments.comments.length)
  let comments = null,
    parentComments = [],
    childComments = [];

  const [comment, setComment] = useState("");
  const [replyComment, setReplyComment] = useState(false);
  const [replyCommentContent, setReplyCommentContent] = useState("");
  const [relycommentId, setRelycommentId] = useState(null);

  if (props.comments.comments.length >= 1) {
    comments = props.comments.comments;
    parentComments = comments.filter((comment) => {
      if (!comment.parent_comment_id && !comment.parent_id) {
        return comment;
      } else {
        childComments.push(comment);
      }
      return null;
    });
  } else {
    console.log("no Comments");
  }
  return (
    <div className={classes.Row}>
      <div className={classes.ItemCenter}>
        <h2 style={{ borderTop: "none" }}>Comments</h2>
        <div className={classes.Comments}>
          {parentComments ? (
            parentComments.map((comment) => {
              const nestedComments = {};
              nestedComments[`nested${comment.id}`] = childComments.filter(
                (nested) => {
                  if (nested.parent_comment_id) {
                    return nested.parent_comment_id === comment.id;
                  } else if (nested.parent_id) {
                    return nested.parent_id === comment.id;
                  } else return null;
                }
              );
              return (
                <Fragment key={comment.id}>
                  <div className={classes.ParentComment}>
                    <img src={comment.user.profile_picture} alt="" />
                    <div className={classes.InnerComment}>
                      <p>
                        {comment.user.name
                          ? comment.user.name
                          : comment.user.email}
                        <small>
                          {new Date(comment.created_at).toString().slice(4, 15)}
                        </small>
                      </p>
                      <p>{comment.content}</p>
                      <div className={classes.BtnsComments}>
                        {replyComment && comment.id === relycommentId ? (
                          <form
                            className={`${classes.AddComment} ${classes.BtnsComments}`}
                            onSubmit={(event) => {
                              event.preventDefault();
                              if (replyCommentContent.trim() !== "") {
                                let vehicleId = props.comments.id;
                                if (!vehicleId) {
                                  vehicleId = props.vihecleId;
                                  props.onReplyToModerator(
                                    props.postState,
                                    vehicleId,
                                    replyCommentContent,
                                    comment.id
                                  );
                                } else {
                                  props.onPostAddComment(
                                    props.postState,
                                    vehicleId,
                                    replyCommentContent,
                                    comment.id
                                  );
                                }
                                setReplyComment(false);
                                setReplyCommentContent("");
                              }
                            }}
                          >
                            <input
                              type="text"
                              placeholder="Your reply ..."
                              autoFocus
                              value={replyCommentContent}
                              onChange={(event) =>
                                setReplyCommentContent(event.target.value)
                              }
                            />
                            <button type="submit">post</button>
                          </form>
                        ) : null}
                        <button
                          type="button"
                          onClick={() => {
                            setReplyComment(true);
                            setRelycommentId(comment.id);
                          }}
                        >
                          Reply
                        </button>
                      </div>
                    </div>
                  </div>
                  {nestedComments[`nested${comment.id}`].map((child, i) => {
                    return (
                      <div key={child.id} className={classes.ChildComment}>
                        <img src={child.user.profile_picture} alt="" />
                        <div className={classes.InnerComment}>
                          <p>
                            {child.user.name
                              ? child.user.name
                              : child.user.email}
                            <small>
                              {new Date(child.created_at)
                                .toString()
                                .slice(4, 15)}
                            </small>
                          </p>
                          <p>{child.content}</p>
                        </div>
                      </div>
                    );
                  })}
                </Fragment>
              );
            })
          ) : (
            <p>no comments</p>
          )}
          {!props.vihecleId && (
            <form
              className={`${classes.AddComment} ${classes.BtnsComments}`}
              onSubmit={(event) => {
                event.preventDefault();
                const vehicleId = props.comments.id;
                props.onPostAddComment(
                  props.postState,
                  vehicleId,
                  comment,
                  comment.id
                );
              }}
            >
              <img
                src={
                  props.currentUser ? props.currentUser.profile_picture : null
                }
                alt=""
                width="30px"
              />
              <input
                type="text"
                placeholder="add comment"
                value={comment}
                onChange={(event) => setComment(event.target.value)}
              />
              <button type="submit"> post</button>
            </form>
          )}
        </div>
      </div>
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    //currentUser:
    currentUser: state.Auth.currentUser,
  };
};
const mapDispatchToProps = (dispatch) => {
  return {
    onPostAddComment: (mode, vehicleId, content, parentId) =>
      dispatch(
        actionCreator.postAddComment(mode, vehicleId, content, parentId)
      ),
    onReplyToModerator: (mode, vehicleId, content, parentId) =>
      dispatch(
        actionCreator.replyToModerator(mode, vehicleId, content, parentId)
      ),
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(Commments);
